import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDeliveryReceipt } from '@api/GenerateReceipt.ts';
import { handleReduxError } from '@utils/requests.ts';
import { i18n } from '@components/i18n.ts';

export const fetchDeliveryReceiptThunk = createAsyncThunk(
  'deliveryReceipt/fetchDeliveryReceipt',
  async (processObjectId: string, { rejectWithValue }) => {
    try {
      return await getDeliveryReceipt(processObjectId);
    } catch (error: unknown) {
      return rejectWithValue(handleReduxError(error, i18n.t));
    }
  }
);
